<ion-header>
  <ion-toolbar color="header">
    <ion-buttons slot="start">
      @if (!localStorage.getIsInAppBrowser() && smallScreen && userIsLoggedIn) {
        <ion-menu-button
          menu="appMenu"
          autoHide="false"
          id="appmenuButton"
        ></ion-menu-button>
      }
      @if (!localStorage.hideHeaderBackButton() && back) {
        <ion-button
          id="backButton"
          (click)="goBack()"
        >
          <ion-icon name="arrow-back" color="font-header"></ion-icon>
        </ion-button>
      }
      @if (save) {
        <ion-button
          [disabled]="!answersChanged && !userIsLoggedIn"
          id="saveLessonButton"
          (click)="saveQuestionnaire()"
        >
          <ion-icon name="save" color="font-header"></ion-icon>
        </ion-button>
      }
    </ion-buttons>
    <ion-title class="ion-text-center" [hidden]="isMobile" color="font-header">
      <h1>
        {{ title }}
      </h1>
    </ion-title>

    @if (!localStorage.getIsInAppBrowser() && userIsLoggedIn) {
      <div slot="end" class="activityDiv">
        @if (parserService.announcements.length > 0) {
          <button
            mat-button
            class="announcementAndActivityButton"
            id="showHideAnnouncements"
            (click)="showHideAnnouncements()"
          >
            <fa-icon [icon]="faBullhorn"></fa-icon>
          </button>
        }
      </div>
    }

    @if (!localStorage.getIsInAppBrowser()) {
      <app-language-selection-component
        slot="end"
        [language]="language"
        [useLanguageCode]="true"
        (changeLanguage)="changeLanguage($event)"
      ></app-language-selection-component>
    }
    
    @if (!localStorage.getIsInAppBrowser() && userIsLoggedIn && isSettingsPage()) {
      <ion-buttons slot="end">
        <ion-button
          id="headerLogoutButton"
          (click)="logout()"
        >
          <ion-icon slot="icon-only" name="power"></ion-icon>
        </ion-button>
      </ion-buttons>
    }
    @if (localStorage.getIsInAppBrowser() && userIsLoggedIn) {
      <ion-buttons slot="end">
        <ion-button
          slot="end"
          id="showInvitationsButton"
          (click)="routeToInvitations()"
        >
          <ion-icon name="paper-plane" color="font-header"></ion-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

  @if (parserService.showAnnouncements && parserService.announcements.length > 0 && userIsLoggedIn) {
    <div
      #announcementDiv
      class="announcement"
      [ngClass]="parserService.announcements[parserService.selectedAnnouncement].type"
    >
      <ion-grid>
        <ion-row>
          <ion-col size="10" offset="1" class="announcement-title-container">
            <ion-label class="announcement-title">
              {{
                parserService.announcements[parserService.selectedAnnouncement].title
              }}
            </ion-label>
          </ion-col>
          <ion-col size="1" class="close-icon-container">
            <ion-icon
              name="close"
              id="hideAnnouncementsButton"
              class="close-icon"
              (click)="showHideAnnouncements()"
            ></ion-icon>
          </ion-col>
        </ion-row>

        <ion-row class="announcement-message-container">
          <ion-col size="12">
            <p class="announcement-message" [class.fontSizeMobile]="isMobile">
              {{
                parserService.announcements[parserService.selectedAnnouncement].message
              }}
            </p>
          </ion-col>
        </ion-row>

        <ion-row class="announcement-nav">
          <ion-col size="12" class="nav-container">
            <ion-icon
              name="arrow-back"
              class="nav-icon"
              (click)="previousAnnouncement()"
              [ngClass]="{ 'disabled': parserService.selectedAnnouncement === 0 }"
              [attr.disabled]="parserService.selectedAnnouncement === 0 ? true : null"
            ></ion-icon>
            <span class="nav-text">
              {{ parserService.selectedAnnouncement + 1 }}
              {{ "GENERAL.OF" | translate }}
              {{ parserService.announcements.length }}
            </span>
            <ion-icon
              name="arrow-forward"
              class="nav-icon"
              (click)="nextAnnouncement()"
              [ngClass]="{ 'disabled': parserService.selectedAnnouncement === parserService.announcements.length - 1 }"
              [attr.disabled]="parserService.selectedAnnouncement === parserService.announcements.length - 1 ? true : null"
            ></ion-icon>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  }
</ion-header>
